<app-header></app-header>
<div class="container-fluid">
  @if (_userService.token) {
    <div>
      <div class="alert alert-info" role="alert">
        <p>
          You are logged in as {{ _userService.username }}. <br>
          Token Expires: {{ _userService.token_expires }}
        </p>
        <button mat-raised-button color="primary" (click)="_userService.refreshToken()">Refresh Token</button>&nbsp;
        <button mat-raised-button color="primary" (click)="_userService.logout()">Log Out</button>
      </div>
    </div>
  }
  @if (specimen) {
    <div>
      <h2>{{biosampleId}}</h2>
      <hr>
        <dl fxLayout="column">
          @if (specimen && specimen.hasOwnProperty('name')) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Name:</dt>
              <dd fxFlex="75">{{specimen?.name}}</dd>
            </div>
          }
          @if (specimen && specimen.hasOwnProperty('biosampleId')) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">BioSample ID:</dt>
              @if (!_userService.token) {
                <dd fxFlex="75">
                  <a href="http://www.ebi.ac.uk/biosamples/samples/{{specimen?.biosampleId}}">{{specimen?.biosampleId}}</a>
                </dd>
              }
              @if (_userService.token) {
                <dd fxFlex="75">
                  {{specimen?.biosampleId}}
                </dd>
              }
            </div>
          }
          @if (specimen && specimen.hasOwnProperty('alternativeId') && specimen.alternativeId.length !== 0) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Alternative ID:</dt>
              <dd fxFlex="75">{{specimen.alternativeId.toString()}}</dd>
            </div>
          }
          @if (specimen && specimen.hasOwnProperty('releaseDate')) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Release date:</dt>
              <dd fxFlex="75">{{specimen?.releaseDate}}</dd>
            </div>
          }
          @if (specimen && specimen.hasOwnProperty('updateDate')) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Update date:</dt>
              <dd fxFlex="75">{{specimen?.updateDate}}</dd>
            </div>
          }
          @if ((specimen?.material?.text !== 'pool of specimens' && specimen?.material?.text !=='cell line') ) {
            <div fxLayout="column"
              >
              @if (specimen && specimen?.organism?.hasOwnProperty('sex') && !isOrganoid(biosampleId)) {
                <div fxLayout="row" fxLayout.lt-md="column">
                  <dt fxFlex="25">Sex:</dt>
                  <dd fxFlex="75">
                    <app-robust-link [prefix]="ols_prefix"
                      [link]="specimen?.organism?.sex?.ontologyTerms"
                    [text]="specimen?.organism?.sex?.text"></app-robust-link>
                  </dd>
                </div>
              }
              @if (specimen && specimen?.organism?.hasOwnProperty('biosampleId') && !isOrganoid(biosampleId)) {
                <div fxLayout="row" fxLayout.lt-md="column">
                  <dt fxFlex="25">Organism BioSample Id:</dt>
                  <dd fxFlex="75">
                    @if (!_userService.token) {
                      <app-robust-link [prefix]="organism_prefix" [link]="specimen?.organism?.biosampleId"
                      [text]="specimen?.organism?.biosampleId"></app-robust-link>
                    }
                    @if (_userService.token) {
                      <a [routerLink]="['/organism/' + specimen?.organism?.biosampleId]">{{specimen?.organism?.biosampleId}}</a>
                    }
                  </dd>
                </div>
              }
              @if (specimen && specimen?.organism?.hasOwnProperty('biosampleId') && isOrganoid(biosampleId)) {
                <div fxLayout="row" fxLayout.lt-md="column">
                  <dt fxFlex="25">Specimen BioSample Id:</dt>
                  <dd fxFlex="75">
                    @if (!_userService.token) {
                      <app-robust-link [prefix]="specimen_prefix" [link]="specimen?.organism?.biosampleId"
                      [text]="specimen?.organism?.biosampleId"></app-robust-link>
                    }
                    @if (_userService.token) {
                      <a [routerLink]="['/specimen/' + specimen?.organism?.biosampleId]">{{specimen?.organism?.biosampleId}}</a>
                    }
                  </dd>
                </div>
              }
              @if (specimen && specimen?.organism?.hasOwnProperty('organism')) {
                <div fxLayout="row" fxLayout.lt-md="column">
                  <dt fxFlex="25">Organism:</dt>
                  <dd fxFlex="75">
                    <app-robust-link [prefix]="ols_prefix"
                      [link]="specimen?.organism?.organism?.ontologyTerms"
                    [text]="specimen?.organism?.organism?.text"></app-robust-link>
                  </dd>
                </div>
              }
              @if (specimen && specimen?.organism?.hasOwnProperty('breed') && !isOrganoid(biosampleId)) {
                <div fxLayout="row" fxLayout.lt-md="column">
                  <dt fxFlex="25">Breed:</dt>
                  <dd fxFlex="75">
                    <app-robust-link [prefix]="ols_prefix"
                      [link]="specimen?.organism?.breed?.ontologyTerms"
                    [text]="specimen?.organism?.breed?.text"></app-robust-link>
                  </dd>
                </div>
              }
              @if (specimen && specimen?.organism?.hasOwnProperty('healthStatus')) {
                <div fxLayout="row" fxLayout.lt-md="column">
                  <dt fxFlex="25">Health status:</dt>
                  <dd fxFlex="75">
                    @for (status of specimen?.organism?.healthStatus; track status) {
                      <div fxLayout="row" fxLayout.lt-md="column">
                        <app-robust-link [prefix]="ols_prefix" [link]="status.ontologyTerms"
                        [text]="status.text"></app-robust-link>
                      </div>
                    }
                  </dd>
                </div>
              }
            </div>
          }
          @if (specimen?.description) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Description:</dt>
              <dd fxFlex="75">{{specimen?.description}}</dd>
            </div>
          }
          @if (specimen && specimen.hasOwnProperty('standardMet')) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Standard met:</dt>
              <dd fxFlex="75">{{specimen?.standardMet}}</dd>
            </div>
          }
          @if (specimen && specimen.hasOwnProperty('project')) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Project:</dt>
              <dd fxFlex="75">{{specimen?.project}}</dd>
            </div>
          }
          @if (specimen && specimen.hasOwnProperty('secondaryProject')) {
            <div fxLayout="row" fxLayout.lt-md="column" >
              <dt fxFlex="25">Secondary project:</dt>
              <dd fxFlex="75">{{specimen?.secondaryProject}}</dd>
            </div>
          }
          @if (specimen?.availability) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Availability:</dt>
              <dd fxFlex="75"><a href={{specimen?.availability}}>{{dealWithAvailability(specimen?.availability)}}</a></dd>
            </div>
          }
          @if (specimen && specimen?.hasOwnProperty('organization')) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Organisation:</dt>
              <dd fxFlex="75">
                @for (organization of specimen?.organization; track organization) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <app-robust-link [link]="organization.URL" [text]="organization.name"></app-robust-link>
                    ( {{organization.role}})
                  </div>
                }
              </dd>
            </div>
          }
          @if (specimen && specimen?.hasOwnProperty('material')) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Material:</dt>
              <dd fxFlex="75">
                <app-robust-link [prefix]="ols_prefix" [link]="specimen?.material?.ontologyTerms"
                [text]="specimen?.material?.text"></app-robust-link>
              </dd>
            </div>
          }
          @if (specimen?.sameAs) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Same as:</dt>
              <dd fxFlex="75">{{specimen?.sameAs}}</dd>
            </div>
          }
          @if (specimen?.derivedFrom && !isOrganoid(biosampleId)) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Derived from:</dt>
              <dd fxFlex="75">
                <div fxLayout="row" fxLayout.lt-md="column">
                  @switch (specimen?.material?.text) {
                    @case ('pool of specimens') {
                      @for (derived of specimen?.derivedFrom; track derived; let i = $index) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <!--            <robust-link prefix="http://www.ebi.ac.uk/biosamples/samples/" [link]="derived" [text]="derived"></robust-link>-->
                          @if (i > 0) {
                            <div fxLayout="row" fxLayout.lt-md="column">,</div>
                          }
                          @if (!_userService.token) {
                            <app-robust-link [prefix]="specimen_prefix" [link]="derived" [text]="derived"></app-robust-link>
                          }
                          @if (_userService.token) {
                            <a [routerLink]="['/specimen/' + derived ]">{{derived}}</a>
                          }
                        </div>
                      }
                    }
                    @case ('cell specimen') {
                      <!--ruleset constrain: specimen from organism-->
                      @if (!_userService.token) {
                        <app-robust-link [prefix]="specimen_prefix" [link]="specimen?.derivedFrom"
                        [text]="specimen?.derivedFrom"></app-robust-link>
                      }
                      @if (_userService.token) {
                        <a [routerLink]="['/specimen/' + specimen?.derivedFrom ]">{{specimen?.derivedFrom}}</a>
                      }
                    }
                    @case ('cell culture') {
                      <!--ruleset constrain: specimen from organism or cell specimen-->
                      @if (!_userService.token) {
                        <app-robust-link [prefix]="specimen_prefix" [link]="specimen?.derivedFrom"
                        [text]="specimen?.derivedFrom"></app-robust-link>
                      }
                      @if (_userService.token) {
                        <a [routerLink]="['/specimen/' + specimen?.derivedFrom ]">{{specimen?.derivedFrom}}</a>
                      }
                    }
                    @default {
                      @if (!_userService.token) {
                        <app-robust-link [prefix]="organism_prefix" [link]="specimen?.derivedFrom"
                        [text]="specimen?.derivedFrom"></app-robust-link>
                      }
                      @if (_userService.token) {
                        <a [routerLink]="['/organism/' + specimen?.derivedFrom ]">{{specimen?.derivedFrom}}</a>
                      }
                    }
                  }
                </div>
              </dd>
            </div>
          }
          <div fxLayout="column">
            @switch (specimen?.material?.text) {
              @case ('specimen from organism') {
                @if (specimen && specimen?.specimenFromOrganism?.hasOwnProperty('specimenCollectionDate')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Specimen collection date:</dt>
                    <dd fxFlex="75">{{specimen?.specimenFromOrganism?.specimenCollectionDate?.text}}</dd>
                  </div>
                }
                @if (specimen && specimen?.specimenFromOrganism?.hasOwnProperty('animalAgeAtCollection')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Animal age at collection:</dt>
                    <dd fxFlex="75">{{specimen?.specimenFromOrganism?.animalAgeAtCollection?.text}} {{specimen?.specimenFromOrganism?.animalAgeAtCollection?.unit}}</dd>
                  </div>
                }
                @if (specimen && specimen?.specimenFromOrganism?.hasOwnProperty('developmentalStage')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Developmental stage:</dt>
                    <dd fxFlex="75">
                      <app-robust-link [prefix]="ols_prefix"
                        [link]="specimen?.specimenFromOrganism?.developmentalStage?.ontologyTerms"
                      [text]="specimen?.specimenFromOrganism?.developmentalStage?.text"></app-robust-link>
                    </dd>
                  </div>
                }
                @if (specimen && specimen?.specimenFromOrganism?.hasOwnProperty('organismPart')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Organism part:</dt>
                    <dd fxFlex="75">
                      <app-robust-link [prefix]="ols_prefix"
                        [link]="specimen?.specimenFromOrganism?.organismPart?.ontologyTerms"
                      [text]="specimen?.specimenFromOrganism?.organismPart?.text"></app-robust-link>
                    </dd>
                  </div>
                }
                @if (specimen && specimen?.specimenFromOrganism?.hasOwnProperty('specimenCollectionProtocol')) {
                  <div fxLayout="row" fxLayout.lt-md="column"
                    >
                    <dt fxFlex="25">Specimen collection protocol:</dt>
                    <dd fxFlex="75">
                      @if (specimen?.specimenFromOrganism?.specimenCollectionProtocol?.filename) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <app-robust-link
                            [link]="generateProtocolLink(specimen?.specimenFromOrganism?.specimenCollectionProtocol?.url)"
                          [text]="specimen?.specimenFromOrganism?.specimenCollectionProtocol?.filename"></app-robust-link>
                        </div>
                      }
                      @if (!specimen?.specimenFromOrganism?.specimenCollectionProtocol?.filename) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <app-robust-link [link]="generateProtocolLink(specimen?.specimenFromOrganism?.specimenCollectionProtocol?.url)"
                          [text]="specimen?.specimenFromOrganism?.specimenCollectionProtocol?.url"></app-robust-link>
                        </div>
                      }
                    </dd>
                  </div>
                }
                @if (specimen?.specimenFromOrganism?.fastedStatus) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Fasted status:</dt>
                    <dd fxFlex="75">{{specimen?.specimenFromOrganism?.fastedStatus}}</dd>
                  </div>
                }
                @if (specimen?.specimenFromOrganism?.numberOfPieces?.text) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Number of pieces:</dt>
                    <dd fxFlex="75">{{specimen?.specimenFromOrganism?.numberOfPieces?.text}}</dd>
                  </div>
                }
                @if (specimen?.specimenFromOrganism?.specimenVolume?.text) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Specimen volume:</dt>
                    <dd fxFlex="75">{{specimen?.specimenFromOrganism?.specimenVolume?.text}} {{specimen?.specimenFromOrganism?.specimenVolume?.unit}}</dd>
                  </div>
                }
                @if (specimen?.specimenFromOrganism?.specimenSize?.text) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Specimen size:</dt>
                    <dd fxFlex="75">{{specimen?.specimenFromOrganism?.specimenSize?.text}} {{specimen?.specimenFromOrganism?.specimenSize?.unit}}</dd>
                  </div>
                }
                @if (specimen?.specimenFromOrganism?.specimenWeight?.text) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Specimen weight:</dt>
                    <dd fxFlex="75">{{specimen?.specimenFromOrganism?.specimenWeight?.text}} {{specimen?.specimenFromOrganism?.specimenWeight?.unit}}</dd>
                  </div>
                }
                @if (specimen && specimen.specimenFromOrganism?.hasOwnProperty('specimenPictureUrl') && specimen.specimenFromOrganism.specimenPictureUrl.length !== 0) {
                  <div fxLayout="row" fxLayout.lt-md="column"
                    >
                    <dt fxFlex="25">Specimen picture URL:</dt>
                    <dd fxFlex="75">{{specimen.specimenFromOrganism.specimenPictureUrl.toString()}}</dd>
                  </div>
                }
                @if (specimen?.specimenFromOrganism?.gestationalAgeAtSampleCollection?.text) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Gestational age at sample collection:</dt>
                    <dd fxFlex="75">{{specimen?.specimenFromOrganism?.gestationalAgeAtSampleCollection?.text}} {{specimen?.specimenFromOrganism?.gestationalAgeAtSampleCollection?.unit}}</dd>
                  </div>
                }
              }
              @case ('pool of specimens') {
                @if (specimen && specimen.poolOfSpecimens.hasOwnProperty('poolCreationDate')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Pool creation date:</dt>
                    <dd fxFlex="75">{{specimen.poolOfSpecimens.poolCreationDate.text}}</dd>
                  </div>
                }
                @if (specimen && specimen?.poolOfSpecimens?.hasOwnProperty('poolCreationProtocol')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Pool creation protocol:</dt>
                    <dd fxFlex="75">
                      @if (specimen?.poolOfSpecimens?.poolCreationProtocol?.filename) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <app-robust-link [link]="generateProtocolLink(specimen?.poolOfSpecimens?.poolCreationProtocol?.url)"
                          [text]="specimen?.poolOfSpecimens?.poolCreationProtocol?.filename"></app-robust-link>
                        </div>
                      }
                      @if (!specimen?.poolOfSpecimens?.poolCreationProtocol?.filename) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <app-robust-link [link]="generateProtocolLink(specimen?.poolOfSpecimens?.poolCreationProtocol?.url)"
                          [text]="specimen?.poolOfSpecimens?.poolCreationProtocol?.url"></app-robust-link>
                        </div>
                      }
                    </dd>
                  </div>
                }
                @if (specimen?.poolOfSpecimens?.specimenVolume?.text) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Specimen volume:</dt>
                    <dd fxFlex="75">{{specimen.poolOfSpecimens.specimenVolume.text}} {{specimen.poolOfSpecimens.specimenVolume.unit}}</dd>
                  </div>
                }
                @if (specimen?.poolOfSpecimens?.specimenSize?.text) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Specimen size:</dt>
                    <dd fxFlex="75">{{specimen.poolOfSpecimens.specimenSize.text}} {{specimen.poolOfSpecimens.specimenSize.unit}}</dd>
                  </div>
                }
                @if (specimen?.poolOfSpecimens?.specimenWeight?.text) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Specimen weight:</dt>
                    <dd fxFlex="75">{{specimen.poolOfSpecimens.specimenWeight.text}} {{specimen.poolOfSpecimens.specimenWeight.unit}}</dd>
                  </div>
                }
                @if (specimen && specimen.poolOfSpecimens?.hasOwnProperty('specimenPictureUrl') && specimen.poolOfSpecimens.specimenPictureUrl.length !== 0) {
                  <div fxLayout="row" fxLayout.lt-md="column"
                    >
                    <dt fxFlex="25">Specimen picture URL:</dt>
                    <dd fxFlex="75">{{specimen.poolOfSpecimens.specimenPictureUrl.toString()}}</dd>
                  </div>
                }
              }
              @case ('cell specimen') {
                @if (specimen?.cellSpecimen?.markers) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Markers:</dt>
                    <dd fxFlex="75">{{specimen.cellSpecimen.markers}}</dd>
                  </div>
                }
                @if (specimen && specimen?.cellSpecimen?.hasOwnProperty('cellType')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Cell type:</dt>
                    <dd fxFlex="75">
                      @for (type of specimen?.cellSpecimen?.cellType; track type) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <app-robust-link [prefix]="ols_prefix" [link]="type?.ontologyTerms[0]"
                          [text]="type?.text"></app-robust-link>
                        </div>
                      }
                    </dd>
                  </div>
                }
                @if (specimen && specimen?.cellSpecimen?.hasOwnProperty('purificationProtocol')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Purification protocol:</dt>
                    <dd fxFlex="75">
                      @if (specimen?.cellSpecimen?.purificationProtocol?.filename) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <app-robust-link [link]="generateProtocolLink(specimen?.cellSpecimen?.purificationProtocol?.url)"
                          [text]="specimen?.cellSpecimen?.purificationProtocol?.filename"></app-robust-link>
                        </div>
                      }
                      @if (!specimen?.cellSpecimen?.purificationProtocol?.filename) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <app-robust-link [link]="generateProtocolLink(specimen?.cellSpecimen?.purificationProtocol?.url)"
                          [text]="specimen?.cellSpecimen?.purificationProtocol?.url"></app-robust-link>
                        </div>
                      }
                    </dd>
                  </div>
                }
              }
              @case ('cell culture') {
                @if (specimen && specimen?.cellCulture?.hasOwnProperty('cultureType')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Culture type:</dt>
                    <dd fxFlex="75">
                      <app-robust-link [prefix]="ols_prefix"
                        [link]="specimen?.cellCulture?.cultureType?.ontologyTerms"
                      [text]="specimen?.cellCulture?.cultureType?.text"></app-robust-link>
                    </dd>
                  </div>
                }
                @if (specimen && specimen?.cellCulture?.hasOwnProperty('cellType')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Cell type:</dt>
                    <dd fxFlex="75">
                      <app-robust-link [prefix]="ols_prefix"
                        [link]="specimen?.cellCulture?.cellType?.ontologyTerms"
                      [text]="specimen?.cellCulture?.cellType?.text"></app-robust-link>
                    </dd>
                  </div>
                }
                @if (specimen && specimen?.cellCulture?.hasOwnProperty('cellCultureProtocol')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Cell culture protocol:</dt>
                    <dd fxFlex="75">
                      @if (specimen?.cellCulture?.cellCultureProtocol?.filename) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <app-robust-link [link]="generateProtocolLink(specimen?.cellCulture?.cellCultureProtocol?.url)"
                          [text]="specimen?.cellCulture?.cellCultureProtocol?.filename"></app-robust-link>
                        </div>
                      }
                      @if (!specimen?.cellCulture?.cellCultureProtocol?.filename) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <app-robust-link [link]="generateProtocolLink(specimen?.cellCulture?.cellCultureProtocol?.url)"
                          [text]="specimen?.cellCulture?.cellCultureProtocol?.url"></app-robust-link>
                        </div>
                      }
                    </dd>
                  </div>
                }
                @if (specimen && specimen?.cellCulture?.hasOwnProperty('cultureConditions')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Culture conditions:</dt>
                    <dd fxFlex="75">{{specimen?.cellCulture?.cultureConditions}}</dd>
                  </div>
                }
                @if (specimen && specimen?.cellCulture?.hasOwnProperty('numberOfPassages')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Number of passages:</dt>
                    <dd fxFlex="75">{{specimen?.cellCulture?.numberOfPassages}}</dd>
                  </div>
                }
              }
              @case ('cell line') {
                @if (specimen && specimen?.cellLine?.hasOwnProperty('cellLine')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Cell line:</dt>
                    <dd fxFlex="75">{{specimen?.cellLine?.cellLine}}</dd>
                  </div>
                }
                @if (specimen && specimen?.cellLine?.hasOwnProperty('organism')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Organism:</dt>
                    <dd fxFlex="75">
                      <app-robust-link [prefix]="ols_prefix"
                        [link]="specimen?.cellLine?.organism?.ontologyTerms"
                      [text]="specimen?.cellLine?.organism?.text"></app-robust-link>
                    </dd>
                  </div>
                }
                @if (specimen && specimen?.cellLine?.hasOwnProperty('sex') && !isOrganoid(biosampleId)) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Sex:</dt>
                    <dd fxFlex="75">
                      <app-robust-link [prefix]="ols_prefix"
                        [link]="specimen?.cellLine?.sex?.ontologyTerms"
                      [text]="specimen?.cellLine?.sex?.text"></app-robust-link>
                    </dd>
                  </div>
                }
                @if (specimen && specimen?.cellLine?.hasOwnProperty('biomaterialProvider')) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Biomaterial provider:</dt>
                    <dd fxFlex="75">{{specimen?.cellLine?.biomaterialProvider}}</dd>
                  </div>
                }
                @if (specimen?.cellLine?.catalogueNumber) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Catalogue number:</dt>
                    <dd fxFlex="75">{{specimen.cellLine.catalogueNumber}}</dd>
                  </div>
                }
                @if (specimen?.cellLine?.numberOfPassages) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Number of passages:</dt>
                    <dd fxFlex="75">{{specimen?.cellLine?.numberOfPassages}}</dd>
                  </div>
                }
                @if (specimen?.cellLine?.dateEstablished) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Date established:</dt>
                    <dd fxFlex="75">{{specimen?.cellLine?.dateEstablished.text}}</dd>
                  </div>
                }
                @if (specimen?.cellLine?.publication) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Publication:</dt>
                    <dd fxFlex="75">{{specimen.cellLine.publication}}</dd>
                  </div>
                }
                @if (specimen?.cellLine?.breed?.text && !isOrganoid(biosampleId)) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Breed:</dt>
                    <dd fxFlex="75">
                      <app-robust-link [prefix]="ols_prefix"
                        [link]="specimen.cellLine.breed.ontologyTerms"
                      [text]="specimen.cellLine.breed.text"></app-robust-link>
                    </dd>
                  </div>
                }
                @if (specimen?.cellLine?.cellType?.text) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Cell type:</dt>
                    <dd fxFlex="75">
                      <app-robust-link [prefix]="ols_prefix"
                        [link]="specimen?.cellLine?.cellType?.ontologyTerms"
                      [text]="specimen?.cellLine?.cellType?.text"></app-robust-link>
                    </dd>
                  </div>
                }
                @if (specimen?.cellLine?.cultureConditions) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Culture conditions:</dt>
                    <dd fxFlex="75">{{specimen.cellLine.cultureConditions}}</dd>
                  </div>
                }
                @if (specimen?.cellLine?.cultureProtocol?.url) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Culture protocol:</dt>
                    <dd fxFlex="75">
                      @if (specimen.cellLine.cultureprotocol.filename) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <app-robust-link [link]="generateProtocolLink(specimen.cellLine.cultureProtocol.url)"
                          [text]="specimen.cellLine.cultureProtocol.filename"></app-robust-link>
                        </div>
                      }
                      @if (!specimen.cellLine.cultureprotocol.filename) {
                        <div fxLayout="row" fxLayout.lt-md="column">
                          <app-robust-link [link]="generateProtocolLink(specimen.cellLine.cultureProtocol.url)"
                          [text]="specimen.cellLine.cultureProtocol.url"></app-robust-link>
                        </div>
                      }
                    </dd>
                  </div>
                }
                @if (specimen?.cellLine?.disease?.text) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Disease:</dt>
                    <dd fxFlex="75">
                      <app-robust-link [prefix]="ols_prefix"
                        [link]="specimen.cellLine.disease.ontologyTerms"
                      [text]="specimen.cellLine.disease.text"></app-robust-link>
                    </dd>
                  </div>
                }
                @if (specimen?.cellLine?.karyotype) {
                  <div fxLayout="row" fxLayout.lt-md="column">
                    <dt fxFlex="25">Karyotype:</dt>
                    <dd fxFlex="75">{{specimen.cellLine.karyotype}}</dd>
                  </div>
                }
              }
              <!--        <ng-template ngSwitchDefault>Unrecgonizable specimen type</ng-template>-->
            }
          </div>
          @if (specimen?.customField?.length > 0;) {
            <div fxLayout="column">
              @for (field of specimen?.customField; track field) {
                <div fxLayout="row" fxLayout.lt-md="column">
                  @if (field.name !== 'Sex' && field.name !== 'biosample id' && field.ontologyTerms || field.value) {
                    <dt fxFlex="25">{{field.name}}:</dt>
                  }
                  @if (field.name !== 'Sex' && field.name !== 'biosample id' && field.ontologyTerms || field.value) {
                    <dd fxFlex="75">
                      <app-robust-link [prefix]="ols_prefix" [link]="field.ontologyTerms"
                      [text]="field.value"></app-robust-link>
                      {{field?.unit}}
                    </dd>
                  }
                </div>
              }
            </div>
          }
        </dl>
        <app-related-items source_type="specimen" target_type="paper" [data]="relatedArticles"
        download_key="" [record_id]="biosampleId"></app-related-items>
        <app-related-items source_type="specimen" target_type="specimen"
        download_key="" [record_id]="biosampleId"></app-related-items>
        <app-related-items source_type="specimen" target_type="file"
        download_key="_source.url" [record_id]="biosampleId"></app-related-items>
        <app-related-items source_type="specimen" target_type="analysis"
        download_key="" [record_id]="biosampleId"></app-related-items>
      </div>
    }
    @if (error) {
      <div class="alert alert-danger"><p>{{ error }}</p></div>
    }
  </div>

